<template lang="pug">
.surf-video
  .surf-video__actions(v-if='(showMuteButton || showPlayButton) && !loading')
    b-btn.surf-video__actions-mute.has-icon.icon-only.ml-2(
      v-if='showPlayButton',
      ref='playButton',
      variant='surf-secondary',
      @click='togglePlay'
    )
      i.icon.icon-sm(:class='playBtnIconClass')
    b-btn.surf-video__actions-mute.has-icon.icon-only.ml-2(
      v-if='showMuteButton',
      ref='muteButton',
      variant='surf-secondary',
      @click='toggleMute'
    )
      i.icon.icon-sm(:class='muteBtnIconClass')
  video(
    ref='video',
    :src='src',
    :style='internalStyles',
    :loop='loop',
    :muted='muted',
    :autoplay='autoPlay',
    :controls='controls',
    :playsinline='playsInline',
    :poster='poster'
  )
</template>
<script>
import gaEventMixin from '../mixins/ga_event'

export default {
  mixins: [gaEventMixin],
  data() {
    return {
      loading: true,
      isMuted: true,
      isPaused: true,
      video: null
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    loop: {
      type: Boolean,
      required: false,
      default: false
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: false
    },
    showMuteButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showPlayButton: {
      type: Boolean,
      required: false,
      default: false
    },
    muted: {
      type: Boolean,
      required: false,
      default: true
    },
    controls: {
      type: Boolean,
      required: false,
      default: false
    },
    playsInline: {
      type: Boolean,
      required: false,
      default: true
    },
    poster: {
      type: String,
      required: false,
      default: null
    },
    coverMode: {
      type: Boolean,
      required: false,
      default: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    internalStyles() {
      if (this.coverMode) {
        return Object.assign({}, this.styles, {
          objectFit: 'cover',
          width: '100%'
        })
      }

      return this.styles
    },
    muteBtnIconClass() {
      return this.isMuted ? this.$icons.mute : this.$icons.unmute
    },
    playBtnIconClass() {
      return this.isPaused ? this.$icons.play : this.$icons.pause
    }
  },
  mounted() {
    this.video = this.$refs.video
    this.isMuted = this.video.muted
    this.video.addEventListener('volumechange', this.updateMutedState)
    this.video.addEventListener('play', this.updatePlayState)
    this.video.addEventListener('pause', this.updatePlayState)
    this.loading = false
  },
  beforeDestroy() {
    this.video.removeEventListener('volumechange', this.updateMutedState)
    this.video.removeEventListener('play', this.updatePlayState)
    this.video.removeEventListener('pause', this.updatePlayState)
  },
  methods: {
    updateMutedState() {
      this.isMuted = this.video.muted
    },
    updatePlayState() {
      this.isPaused = this.video.paused
      this.trackEvent(`video_${this.isPaused ? 'paused' : 'play'}`)
    },
    togglePlay() {
      if (this.video.paused) {
        this.video.play()
      } else {
        this.video.pause()
      }

      if (this.$refs.playButton) {
        this.$nextTick(() => {
          this.$refs.playButton.blur()
        })
      }
    },
    toggleMute() {
      this.video.muted = !this.video.muted
      this.trackEvent(`video_${this.video.muted ? '' : 'un'}muted`)

      if (this.$refs.muteButton) {
        this.$nextTick(() => {
          this.$refs.muteButton.blur()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './../assets/scss/_variables.scss';

.surf-video__actions {
  position: absolute;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  height: $btn-height;
  width: 100%;
  max-width: $breakpoint-xl;
  padding-right: $base-spacing-lg;
  margin-top: $base-spacing;
  text-align: right;
}
</style>
